var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.memberLevelIcon)?_c('div',{staticClass:"vip-icon"},[_c('img',{attrs:{"src":_vm.memberLevelIcon}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }